<template>
  <a-tag :color="statusObj.color">
    {{ $t(statusObj.title) }}
  </a-tag>
</template>

<script>
import statusList from '@/utils/returnStatusList'

export default {
  name: 'ReturnStatusTag',

  props: {
    status: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      statusList,
    }
  },

  computed: {
    statusObj() {
      return Object.values(this.statusList).find(obj => obj.code === this.status)
    },
  },

}
</script>
